import { useEffect, useState } from "react";
import { brand, navItems } from "@/mocks/gua";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [keyword, setKeyword] = useState("");

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    if (q) {
      // 单页无独立搜索页，跳转到速递区并在输入框给出提示
      document.querySelector("#fresh")?.scrollIntoView({ behavior: "smooth" });
      setKeyword("");
      setSearchOpen(false);
    }
  };

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-background-50/90 backdrop-blur border-b border-background-200" : "bg-transparent"
      }`}
    >
      <div className="px-4 md:px-6">
        <div className="flex h-16 items-center justify-between gap-4">
          {/* 品牌 */}
          <a href="#home" className="group flex items-center gap-2.5 whitespace-nowrap">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-goblet-fill text-lg" />
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-lg font-bold text-foreground-950">{brand.name}</span>
              <span className="mt-0.5 hidden text-[11px] text-foreground-500 sm:block">
                深度吃瓜 · 看懂热搜
              </span>
            </span>
          </a>

          {/* 桌面导航 */}
          <nav className="hidden items-center gap-1 lg:flex">
            {navItems.map((n) => (
              <a
                key={n.key}
                href={n.href}
                className="whitespace-nowrap rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-600"
              >
                {n.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-1.5">
            <button
              type="button"
              onClick={() => setSearchOpen((v) => !v)}
              aria-label="搜索"
              className="flex h-9 w-9 items-center justify-center rounded-md text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-600"
            >
              <i className="ri-search-line text-lg" />
            </button>
            <a
              href="#newsletter"
              className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm text-background-50 transition-colors hover:bg-primary-600 sm:inline-flex"
            >
              订阅吃瓜
            </a>
            <button
              type="button"
              onClick={() => setMenuOpen((v) => !v)}
              aria-label="菜单"
              className="flex h-9 w-9 items-center justify-center rounded-md text-foreground-700 transition-colors hover:bg-background-100 lg:hidden"
            >
              <i className={`text-xl ${menuOpen ? "ri-close-line" : "ri-menu-line"}`} />
            </button>
          </div>
        </div>

        {/* 搜索框 */}
        {searchOpen && (
          <form
            onSubmit={handleSearch}
            className="flex items-center gap-2 rounded-md border border-background-200 bg-background-50 px-3 py-2 mb-3"
          >
            <i className="ri-search-line text-sm text-foreground-400" />
            <input
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜一下最近在吃哪个瓜…"
              className="w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
            />
            <button type="submit" className="whitespace-nowrap rounded-md bg-primary-500 px-3 py-1 text-xs text-background-50 hover:bg-primary-600">
              搜索
            </button>
          </form>
        )}

        {/* 移动端菜单 */}
        {menuOpen && (
          <nav className="border-t border-background-200 py-3 lg:hidden">
            <div className="flex flex-col gap-1">
              {navItems.map((n) => (
                <a
                  key={n.key}
                  href={n.href}
                  onClick={() => setMenuOpen(false)}
                  className="rounded-md px-3 py-2.5 text-sm text-foreground-700 hover:bg-background-100 hover:text-primary-600"
                >
                  {n.label}
                </a>
              ))}
            </div>
          </nav>
        )}
      </div>
    </header>
  );
}